import React from 'react'
import type { FC } from 'react'
import { Button, Typography } from '@mui/material'
import SnackbarBase from 'redesign/components/atoms/snackbar-base/snackbar-base'
import type { SnackbarProps } from './types'

const Snackbar: FC<SnackbarProps> = ({ onAction, actionText, ...rest }) => (
  <SnackbarBase
    {...rest}
    action={
      <Button onClick={onAction} size="small">
        <Typography variant="buttonSmall">{actionText}</Typography>
      </Button>
    }
  />
)

export default Snackbar
